module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<label><input type=\"checkbox\" name=\"popup-toggler\" on-click=\"onTogglePopupClick\"/>&nbsp;показать всплывающее\n		окно</label>\n</div>\n\n<div class=\"row\">\n	<label><input type=\"checkbox\" name=\"log-toggler\" on-click=\"onToggleLogClick\"/>&nbsp;показать лог</label>\n</div>")
  }
  return __output.join("");

}